import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { Szmd036aRequest, Szmd036aResponse, SZMD036AService } from 'sg-api';
import { map, timeout, catchError } from 'rxjs/operators';
import { ApiCommonService } from 'cbc-shared-lib';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

@Injectable({
  providedIn: 'root'
})
export class UsedSzmd036aService {
  /** 指定された売掛金の詳細情報情報取得のSubject */
  private _contractorDetail$: Subject<Szmd036aResponse> = new Subject<Szmd036aResponse>();

  /**
   * 指定された売掛金の詳細情報情報取得のobservable提供
   *
   * @readonly
   * @memberof UsedSzmd036aService
   */
  get contractorValueChanges(): Observable<Szmd036aResponse> {
    return this._contractorDetail$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SZMD036AService} sZMD036AService
   * @param {ApiCommonService} apiCommonService
   * @memberof InitialInfoService
   */
  constructor(private sZMD036AService: SZMD036AService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   *売掛金の詳細情報情報取得API呼び出し
   *
   * @param {*} value
   * @memberof UsedSzmd036aService
   */
  searchContractor(cdtmnyNo: string, cdtmnyRrkNo: string, targetYmd: string): Observable<Szmd036aResponse> {
    // リクエスト情報生成
    console.log(targetYmd);
    let request: Szmd036aRequest = {
      cdtmnyNo: cdtmnyNo,
      cdtmnyRrkNo: cdtmnyRrkNo,
      targetYmd: targetYmd,
      conversCode: "SZMD001"
    };
    console.log(request);
    return this.sZMD036AService.c16RSZMD036APost(this.apiCommonService.setRequestCommon(<any>request),'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._contractorDetail$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SZMD036A');
          return throwError(err.message);
        }));
  }
}
